import React from 'react';

import Header from './Header';
import MainHeader from './MainHeader';
import Footer from './Footer';
import Sidebar from './SideNavigation';
import SidebarOryza from './SideNavigation';



const ContactUs = () => {
    return (
        <div className="hotale-page-wrapper" id="hotale-page-wrapper">
            <Header />
            <MainHeader />
            <Sidebar />
            <SidebarOryza />
            <div className="gdlr-core-page-builder-body">
                {/* Hero Section */}
                <div className="gdlr-core-pbf-wrapper" style={{ padding: '300px 0px 160px 0px' }} data-skin="white" id="gdlr-core-wrapper-1">
                    <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#0a0a0a' }}>
                        <div
                            className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                            style={{
                                backgroundImage: 'url(/bbkandy/images/contact/contact2.webp)',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                opacity: 0.6
                            }}
                            data-parallax-speed="0"
                        ></div>
                    </div>
                    <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                            <div className="gdlr-core-pbf-element">
                                <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr">
                                    <div className="gdlr-core-title-item-title-wrap">
                                        <h1
  style={{
    fontFamily: "'Comic Neue', cursive",
    fontWeight: 600,
    fontSize: '75px',
    lineHeight: '90px',
    color: 'white',
  }}
>
  Contact Us
</h1>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Info Section */}
                <div className="gdlr-core-pbf-wrapper" style={{ padding: '30px 0px 20px 0px' }} data-skin="White Text">
                    <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#eeb85e' }}>
                        <div
                            className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                            style={{ opacity: 0.5, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            data-parallax-speed="0.2"
                        ></div>
                    </div>
                    <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container contactleft">
                            {/* Phone Info */}
                            <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-1">
                                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                                                <div
                                                    className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                                                    style={{
                                                        backgroundColor: '#3A4A26',
                                                        borderRadius: '40px',
                                                        padding: '20px'
                                                    }}
                                                >
                                                    <i
                                                        className="gdlr-core-icon-item-icon fa fa-phone gdlr-core-skin-e-content"
                                                        style={{
                                                            color: '#eeb85e',
                                                            fontSize: '40px',
                                                            minWidth: '40px',
                                                            minHeight: '40px'
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                                                <div className="gdlr-core-title-item-title-wrap">
                                                    <h3
                                                        className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                                        style={{
                                                            fontSize: '26px',
                                                            letterSpacing: '0px',
                                                            textTransform: 'none',
                                                            color: '#3A4A26'
                                                        }}
                                                    >
                                                        Call Us
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                                                <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#3A4A26' }}>
                                                    <p>We are waiting for your call and<br />can't wait to have you at Banana Bunks.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                                <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                                                    <p><a style={{ textDecoration: 'underline' }} href="tel:+94767008800">+94 76 700 8800</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Email Info */}
                            <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-2">
                                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                                                <div
                                                    className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                                                    style={{
                                                        backgroundColor: '#3A4A26',
                                                        borderRadius: '40px',
                                                        padding: '24px'
                                                    }}
                                                >
                                                    
                                                    <i
                                                        className="gdlr-core-icon-item-icon fa-regular fa-envelope gdlr-core-skin-e-content"
                                                        style={{
                                                            color: '#eeb85e',
                                                            fontSize: '31px',
                                                            minWidth: '31px',
                                                            minHeight: '31px'
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                                                <div className="gdlr-core-title-item-title-wrap">
                                                    <h3
                                                        className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                                        style={{
                                                            fontSize: '26px',
                                                            letterSpacing: '0px',
                                                            textTransform: 'none',
                                                            color: '#3A4A26'
                                                        }}
                                                    >
                                                        Email Us
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                                                <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#3A4A26' }}>
                                                    <p>Whether it's for you or a group of travellers,<br />drop us an email with all your enquires.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                                <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                                                    <p>
                                                        <a style={{ textDecoration: 'underline' }} href="mailto:reservations@oryzaleisure.com">
                                                            <span>reservations@oryzaleisure.com</span>
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Location Info */}
                            <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-3">
                                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                                                <div
                                                    className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                                                    style={{
                                                        backgroundColor: '#3A4A26',
                                                        borderRadius: '40px',
                                                        padding: '24px'
                                                    }}
                                                >
                                                    <i
                                                        className="gdlr-core-icon-item-icon fa fa-location-arrow gdlr-core-skin-e-content"
                                                        style={{
                                                            color: '#eeb85e',
                                                            fontSize: '31px',
                                                            minWidth: '31px',
                                                            minHeight: '31px'
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                                                <div className="gdlr-core-title-item-title-wrap">
                                                    <h3
                                                        className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                                        style={{
                                                            fontSize: '26px',
                                                            letterSpacing: '0px',
                                                            textTransform: 'none',
                                                            color: '#3A4A26'
                                                        }}
                                                    >
                                                        Location
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                                                <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#3A4A26' }}>
                                                    <p>139/1 Aniwatta Circular Rd,<br />Kandy 20000</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                                <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                                                    <p><a style={{ textDecoration: 'underline' }} href="https://maps.app.goo.gl/i682sWvR6ArMiskG6" target="_blank" rel="noopener noreferrer">View On Google Map</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Form Section */}
                <div className="gdlr-core-pbf-wrapper" style={{ padding: '90px 0px 35px 0px' }}>
                    <div className="gdlr-core-pbf-background-wrap bbkandybg"></div>
                    <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                            <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" data-skin="Contact Field" id="gdlr-core-column-4">
                                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js" style={{ maxWidth: '760px' }}>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr green_back_second">
                                                <div className="gdlr-core-title-item-title-wrap">
                                                    <h3
                                                        className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                                        style={{
                                                            fontSize: '39px',
                                                            fontWeight: 600,
                                                            letterSpacing: '0px',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                        Leave us your message 
                                                    </h3>
                                                </div>
                                                <span
                                                    className="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                                    style={{
                                                        fontSize: '19px',
                                                        fontStyle: 'normal',
                                                        letterSpacing: '0px'
                                                    }}
                                                >
                                                    and we will get back to you.
                                                </span>
                                            </div>
                                        </div>
                                        <div className="gdlr-core-pbf-element">
                                            <div className="gdlr-core-contact-form-7-item gdlr-core-item-pdlr gdlr-core-item-pdb">
                                                <div role="form" className="wpcf7" id="wpcf7-f1979-p1964-o1" lang="en-US" dir="ltr">
                                                    <div className="screen-reader-response">
                                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                                        <ul></ul>
                                                    </div>
                                                    <form id="contact">
                                                        <input type="text" id="name" name="name" placeholder="Name*" className="input" required />

                                                        <input type="text" id="email" name="email" placeholder="Email*" className="input" required />

                                                        <input type="text" id="mobile" name="mobile" placeholder="Mobile*" className="input" required />

                                                        <input type="text" name="hotel" id="hotel" value="bbkandy" style={{ display: 'none' }} />

                                                        <textarea name="message" rows="20" cols="20" id="message" placeholder="Message*" className="input" required></textarea>

                                                        <div
                                                            id="success"
                                                            className="message success"
                                                            style={{
                                                                display: 'none',
                                                                backgroundColor: 'green',
                                                                padding: '10px',
                                                                color: '#ffffff',
                                                                marginBottom: '10px',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            Your message is successfully sent...
                                                        </div>

                                                        <input type="submit" name="submit" value="Submit" className="submit-button" 
                                                        style={{ backgroundColor : '#EEB85E' , color : '#3A4A26', }}/>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Map Section */}
                <div className="gdlr-core-pbf-wrapper" style={{ padding: '0px', backgroundColor: '#eeb85e' }}>
                    <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space">
                            <div className="gdlr-core-pbf-element">
                                <div className="gdlr-core-wp-google-map-plugin-item gdlr-core-item-pdlr gdlr-core-item-pdb" style={{ paddingBottom: '0px' }}>
                                    <div className="wpgmp_map_container wpgmp-map-1" rel="map1">
                                        <iframe
                                            title="Google Map Location"
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15830.128927591984!2d80.6264964!3d7.2939383!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae3694941dd11a7%3A0xa1f486bfb14481f6!2sBanana%20Bunks%20Kandy!5e0!3m2!1sen!2slk!4v1712176443146!5m2!1sen!2slk"
                                            width="100%"
                                            height="450"
                                            style={{ border: '0' }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            {/* Back to Top Button */}
            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>
        </div>
    );
};

export default ContactUs;